const WishlistStorage={

    key:"seek_wishlist",

    load(){

        return JSON.parse(
            localStorage.getItem(this.key)||"[]"
        );

    },

    save(items){

        localStorage.setItem(
            this.key,
            JSON.stringify(items)
        );

    },

    clear(){

        localStorage.removeItem(this.key);

    }

};